import { render, staticRenderFns } from "./journeyPreview.vue?vue&type=template&id=5a42917f&scoped=true&"
import script from "./journeyPreview.vue?vue&type=script&lang=js&"
export * from "./journeyPreview.vue?vue&type=script&lang=js&"
import style0 from "./journeyPreview.vue?vue&type=style&index=0&id=5a42917f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a42917f",
  null
  
)

export default component.exports